<template>
<div id="app_mobile_aside" style="display:none;">
  <div class="row h-100">
    <div class="col-8 h-100 shadow-sm bg-white">
      <div class="text-left m-2 pt-4" id="mobile_aside_menu_close_btn" @click="closeMenu()">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 0 24 24"
            fill="#a0a0a0"
            width="24"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
          />
        </svg>
      </div>
      <div class="mt-5" id="sidebar_menu">
        <ul class="list-unstyled">
          <li v-for="(item, index) in menu" :key="index" :class="item.url == $route.fullPath ? 'sidebar_active_item sidebar_item' : 'sidebar_item'">
            <router-link :to="item.url" v-if="is_authenticated || !item.need_auth">
              <span v-html="item.icon"></span>
              <span class="pr-2">{{ item.title }}</span>
            </router-link>
            <span v-else style="cursor: not-allowed !important;">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="#a0a0a0"><g fill="none"><path d="M0 0h24v24H0V0z"/><path d="M0 0h24v24H0V0z" opacity=".87"/></g><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/></svg>
                <span class="pr-2">{{ item.title }}</span>
              </span>
          </li>
          <li class="sidebar_item">
            <router-link to="/tickets">
              <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24"
                    fill="#a0a0a0" width="24">
                <g>
                  <rect fill="none" height="24" width="24"/>
                </g>
                <g>
                  <g>
                    <path
                        d="M21,12.22C21,6.73,16.74,3,12,3c-4.69,0-9,3.65-9,9.28C2.4,12.62,2,13.26,2,14v2c0,1.1,0.9,2,2,2h1v-6.1 c0-3.87,3.13-7,7-7s7,3.13,7,7V19h-8v2h8c1.1,0,2-0.9,2-2v-1.22c0.59-0.31,1-0.92,1-1.64v-2.3C22,13.14,21.59,12.53,21,12.22z"/>
                    <circle cx="9" cy="13" r="1"/>
                    <circle cx="15" cy="13" r="1"/>
                    <path
                        d="M18,11.03C17.52,8.18,15.04,6,12.05,6c-3.03,0-6.29,2.51-6.03,6.45c2.47-1.01,4.33-3.21,4.86-5.89 C12.19,9.19,14.88,11,18,11.03z"/>
                  </g>
                </g>
              </svg>
              <span class="pr-2">آموزش و پشتیبانی</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-4 h-100" @click="closeMenu()"></div>
  </div>
</div>
</template>

<script>
import $ from 'jquery'
import menu from "@/components/main/aside-marketing";
import {mapGetters} from "vuex";
export default {
  name: "mobile-aside",
  computed: {
    ...mapGetters('dashboard', [
      'dashboard', "status"
    ]),

    ...mapGetters("pardakhtShakhsi", [
      "form_data"
    ]),

    ...mapGetters('user', [
      'is_authenticated',
      'is_authenticated_pending'
    ]),
  },
  data() {
    return {
      menu : menu
    };
  },
  methods: {
    closeMenu() {
      $('#app_mobile_aside').animate({width: 'toggle'}, 100);
    }
  }
};
</script>
